import { IConstraintMaxFracFleetPerAreaDetail } from '../../interfaces/iconstraint-max-frac-fleet-per-area-detail';
import { Area } from '../area';
import { ConstraintMaxFracFleetPerArea } from '../constraint-max-frac-fleet-per-area';

export class ConstraintMaxFracFleetPerAreaDetailBase {
  ConstraintMaxFracFleetPerAreaDetailId: number;
  ConstraintMaxFracFleetPerAreaId: number;
  AreaId: number | null;
  MaximumNumber: number | null;
  FracWindowMonths: number | null;
  DaysBetweenFracs: number | null;
  EffectiveStartDate: Date | null;
  EffectiveFinishDate: Date | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Area?: Area;
  ConstraintMaxFracFleetPerArea?: ConstraintMaxFracFleetPerArea;

  constructor(item?: IConstraintMaxFracFleetPerAreaDetail) {
    if (item) {

      this.ConstraintMaxFracFleetPerAreaDetailId = item.ConstraintMaxFracFleetPerAreaDetailId;
      this.ConstraintMaxFracFleetPerAreaId = item.ConstraintMaxFracFleetPerAreaId;
      this.AreaId = item.AreaId;
      this.MaximumNumber = item.MaximumNumber;
      this.FracWindowMonths = item.FracWindowMonths;
      this.DaysBetweenFracs = item.DaysBetweenFracs;
      this.EffectiveStartDate = item.EffectiveStartDate ? new Date(item.EffectiveStartDate) : null;
      this.EffectiveFinishDate = item.EffectiveFinishDate ? new Date(item.EffectiveFinishDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Area = new Area(item.Area);
      this.ConstraintMaxFracFleetPerArea = new ConstraintMaxFracFleetPerArea(item.ConstraintMaxFracFleetPerArea);
    }
  }
}